<template>
    <div class="modal modal-slide-in new-user-modal show fade" id="modals-slide-in" style="display: block;background: #000000a1;" v-if="pipeline.toggleActiveModel">
        <div class="modal-left-dialog" v-on:click="closeClientView()"></div>
        <div class="modal-dialog">
            <!-- route('client.store') post-->
          <form class="add-new-user modal-content pt-0">
            <button id="edit_tasks_close" type="button" class="close mt-1 mb-1" data-dismiss="modal" aria-label="Close" ref="closeAddClient" v-on:click="closeClientView()">x</button>
            <div class="modal-header mb-1">
              <h5 class="modal-title kanban-title mt-1 mb-1" id="exampleModalLabel" >Edit Task</h5>
            </div>
            <div class="modal-body flex-grow-1">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="editModal-tab" data-toggle="tab" href="#editModal" aria-controls="password"
                            role="tab" aria-selected="true" ref="edit_modal_trigger" @click="activateTabs('edit_modal')">Edit</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="activityModel-tab" data-toggle="tab" href="#activityModel"
                            aria-controls="password" role="tab" aria-selected="false" ref="activity_model_trigger" @click="activateTabs('activity_model')">Activity</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="dispute_activityModel-tab" data-toggle="tab" href="#dispute_activityModel"
                            aria-controls="password" role="tab" aria-selected="false" ref="dispute_activity_model_trigger" @click="activateTabs('dispute_activity_model')">Dispute Activity</a>
                    </li>

                </ul>
                <div class="tab-content">
                    <div class="tab-pane mx-auto active" id="emailModal" aria-labelledby="emailModal-tab" role="tabpanel" ref="edit_modal">
                        <edit-pipeline-client @refresh-client="handleRefreshEvent"></edit-pipeline-client>
                    </div>

                    <div class="tab-pane mx-auto" id="activityModel" aria-labelledby="activityModel-tab" role="tabpanel" ref="activity_model">
                        <pipeline-activity></pipeline-activity>
                    </div>

                    <div class="tab-pane mx-auto" id="dispute_activityModel" aria-labelledby="dispute_activityModel-tab" role="tabpanel" ref="dispute_activity_model">
                        <dispute-activity></dispute-activity>
                    </div>

                </div>
            </div>
          </form>
        </div>
      </div>
</template>
<script>
import { ref, reactive } from 'vue'
import {usePipelineStore} from '../../../../../stores/PipelineStore.js';
export default{
    name:"ClientPipelineModal",
    setup(){
        const edit_modal = ref(),
        activity_model = ref(),
        dispute_activity_model = ref(),
        pipeline = usePipelineStore()
        return{
            edit_modal,
            activity_model,
            dispute_activity_model,
            pipeline
        }
    },
    methods:{
        activateTabs(val){
            const array = ['edit_modal','activity_model','dispute_activity_model']
            array.forEach(element => {
                const tabTrigger = this.$refs[element+'_trigger'],
                tabActive = this.$refs[element];
                if(element == val){
                    tabTrigger.classList.add('active');
                    tabActive.classList.add('active');
                }else{
                    tabTrigger.classList.remove('active');
                    tabActive.classList.remove('active');
                }
            });
        },
        toggleModel(){
            this.pipeline.toggleActiveModel = !this.pipeline.toggleActiveModel;
        },
        closeClientView(){
            this.toggleModel()
            this.pipeline.pipeline_id = null;
            this.pipeline.client_id = null;
        },
        handleRefreshEvent() {
            this.$emit('refresh');
        },
    }
}
</script>
<style>
#edit_tasks_close{
    background: #efefef;
    border: 0;
    border-radius: 0.375rem;
    box-sizing: content-box;
    color: #4b465c;
    height: 2.125rem;
    opacity: .5;
    padding: 0.15em;
    width: 2.125rem;
    font-size: 17px;
    color: black;
}
.kanban-title{
    line-height: 1.47;
    margin-bottom: 0;
}
.modal-left-dialog{
    height: 100%;
    width:75%;
    cursor:pointer;
}
</style>
